require('lib/onload');

const Radar = require('lib/radar').radar;
const config = require('Cloud/config');

const radar = Radar(config.get('DEV_SERVER') ? '_dev' : '', config.get('user.email'), '', config.get('x-page-id'));

window.RADAR = radar;

module.exports = radar;
